function retrieveWorkshops() {
    return new Promise((resolve, reject) => { 
        $.ajax({
            url: 'workshops',
            type: 'GET',
            dataType: 'json',
            success: function(data) {
                if (data.length === 0) {
                    console.log("No workshops were found")
                    resolve([]);
                } 
                resolve(data);
            },
            error: function(xhr, status, error) {
                console.error('Request failed. Status:', status, 'Error:', error);
                reject(error);
            }
        });
    });
}

function getMarketMapDetails() {
    return new Promise((resolve, reject) => { 
        $.ajax({
            url: 'details',
            type: 'GET',
            dataType: 'json',
            success: function(data) {
                if (data.length === 0) {
                    console.log("No map details were found for the current market")
                    resolve([]);
                } 
                resolve(data);
            },
            error: function(xhr, status, error) {
                console.error('Request failed. Status:', status, 'Error:', error);
                reject(error);
            }
        });
    });
}

function createWorkshopDetailHtml(workshop) {
    return new Promise((resolve, reject) => { 
        $.ajax({
            url: 'workshops/detail',
            type: 'POST',
            dataType: 'text',
            data: {
                workshop: workshop
            },
            success: function(data) {
                resolve(data);
            },
            error: function(xhr, status, error) {
                console.error('Request failed. Status:', status, 'Error:', error);
                reject(error);
            }
        });
    });
}

async function setMarkers(map, bounds, items) {

    let markers = [];
    const infoWindow = new google.maps.InfoWindow();

    for(let item of items) {
        if (item.latitude == null || item.longitude == null) {
            continue;
        }

		const content = document.createElement('div');
		content.classList.add('custom-marker');
		content.innerHTML = `<img class="map-marker" src="assets/img/icons/map-marker.png">`;

        let marker = new google.maps.marker.AdvancedMarkerElement({
            map,
            position: {
                lat: item.latitude,
                lng: item.longitude
            },
            title: item.name,
			content
        })

        markers.push(marker);
        bounds.extend(marker.position);


        marker.addListener('click', async ({ domEvent, latLng }) => {
            const { target } = domEvent;
            infoWindow.close();
            let html = await createWorkshopDetailHtml(item);
            infoWindow.setContent(html);
            infoWindow.open(marker.map, marker);
        });
    }

    return markers;
}

async function initMap() {
    let workshopMapId = 'map';
    // Default details (Spain)
    let mapOptions = {
        center: {
            lat: 40.416775,
            lng: -3.703790
        },
        zoom: 6,
        mapId: workshopMapId
    };
    try {
        let details = await getMarketMapDetails();
        mapOptions = {
            center: {
                lat: details.latitude,
                lng: details.longitude
            },
            zoom: details.zoom,
            mapId: workshopMapId
        };
    } catch (error) {
        console.error('Failed to retrieve map information: ', error);
    }

    
    let workshop_map = new google.maps.Map(document.getElementById('map'), mapOptions);

    let workshops = [];
    try {
        workshops = await retrieveWorkshops();
    } catch (error) {
        console.error('Failed to retrieve workshops: ', error);
    }

    let bounds = new google.maps.LatLngBounds();

    if (workshops.length !== 0) {
        await setMarkers(workshop_map, bounds, workshops);
        workshop_map.fitBounds(bounds);
    }
}

